var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('div',{staticClass:"icon",class:`has-text-${_vm.trueType}`},[_c('i',{staticClass:"mdi",class:`mdi-${_vm.trueIcon}`})]):_c('div',{staticClass:"icon",class:`has-text-${_vm.falseType}`},[_c('i',{staticClass:"mdi",class:`mdi-${_vm.falseIcon}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }